import React from "react"
import Layout from "../components/layout"
import { Row, Col } from "react-bootstrap"
import { Link, graphql } from "gatsby"
import BlogHeading from "../components/BlogHeading"
import styles from "./blogPost.module.scss"
import Meeting from "../assets/Meeting.svg"
import Webapplication from "../assets/webapplication.svg"
import Responsive from "../assets/responsive.svg"

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        date
        title
      }
      html
    }
  }
`
const Blog = props => {
  return (
    <Layout>
      <BlogHeading />
      <Col className={styles.articalTop}>
        <Row className={`m-auto pt-2 bg-light ${styles.articalwrap}`}>
          <Col xs={12} sm={12} md={9} lg={9} className="py-2 px-2 mb-2">
            <p className="text-muted pl-4">
              Posted on: {props.data.markdownRemark.frontmatter.date}
            </p>
            <h3 className="text-center text-secondary">
              {props.data.markdownRemark.frontmatter.title}
            </h3>
            <div
              className={`text-left ${styles.articalContent}`}
              dangerouslySetInnerHTML={{
                __html: props.data.markdownRemark.html,
              }}
            ></div>

            <Link to="/Blog" type="button" className="mr-4 float-right">
              <span className="text-danger">
                <strong> &lt;</strong>
              </span>
              <abbr title="Go to Blog items">All Posts</abbr>
            </Link>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={3}
            lg={3}
            className={`py-2 px-2 mb-2 ${styles.sideCol} `}
          >
            <p className="text-center">Advertisment</p>
            <Meeting className="col-lg-12" />
            <Webapplication className="col-lg-12" />
            <Responsive className="col-lg-12" />
          </Col>
        </Row>
      </Col>
    </Layout>
  )
}
export default Blog
